/**
 * A titled band of a panel.
 *
 * Lived in `overview/overviewLayout.tsx` while Overview was the only screen with real sectioning.
 * The merged Usage tab is the second consumer, which is the bar for promoting something to shared —
 * and the reason it matters is not reuse but consistency: Overview's question-shaped headings
 * ("Who's using nCoder?", "What did it cost?") were the strongest information design on the panel,
 * while Billing and Usage were flat card stacks with `aria-label`s and no visible headings at all.
 * Two of four screens therefore gave a screen-reader user no document outline, so this is an
 * accessibility fix as much as a visual one.
 *
 * Sections are the page's structure, so they are real headings, not styled divs.
 */
export function Section({
  title,
  action,
  children,
}: {
  title: string;
  /** Right-aligned affordance on the heading line — usually a link into the tab that owns the detail. */
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className="mt-5 first:mt-3">
      <div className="mb-2 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
        <h2 className="oa-title">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
